import React from 'react';

import ImageWithBasePath from '@/core/data/img/ImageWithBasePath';

const Loader = () => {
  return (
    <div>
      <div id="global-loader">
        <div className="loader-img">
          <ImageWithBasePath
            src="assets/img/loader.png"
            className="img-fluid"
            alt="Global"
            isBackend={false}
          />
        </div>
      </div>
    </div>
  );
};

export default Loader;
